import React, {useEffect} from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Styles from './styles.module.scss';


// Общая рамка модалок кабинета в новом дизайне
// size: 'sm' (420px) | 'md' (520px, по умолчанию) | 'lg' (640px)
const DsModal = ({open, onClose, title, subtitle, size = 'md', children, brush = false}) => {
    // Блокируем прокрутку страницы, пока модалка открыта.
    // Встроенный lockScroll из reactjs-popup НЕ используем: он вешает на <body> overflow: auto
    // даже у закрытых модалок — body становится отдельным скроллером, и на iPhone (Safari/Chrome iOS)
    // верх и низ страницы уходят под панели браузера и до них не докрутить.
    useEffect(() => {
        if (!open) return undefined;
        const html = document.documentElement;
        const prev = html.style.overflow;
        html.style.overflow = 'hidden';
        return () => { html.style.overflow = prev; };
    }, [open]);

    return (
    <Popup
        open={!!open}
        modal
        nested
        closeOnDocumentClick
        onClose={onClose}
        className="ds-modal"
    >
        <div className={`${Styles.modal} ${Styles[size]}`}>
            <button type="button" className={Styles.close} onClick={onClose} aria-label="Close">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
                </svg>
            </button>
            {(title || subtitle) && (
                <div className={Styles.header}>
                    {title && <div className={`${Styles.title} ${brush ? Styles.titleBrush : ''}`}>{title}</div>}
                    {subtitle && <div className={Styles.subtitle}>{subtitle}</div>}
                </div>
            )}
            <div className={Styles.body}>{children}</div>
        </div>
    </Popup>
    );
};

export default DsModal;
